import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import { LoadingScreen } from "../components/common/LoadingScreen";
import { StoreLayout } from "../components/layout/StoreLayout";

const HomePage = lazy(() => import("../pages/HomePage"));
const ProductsPage = lazy(() => import("../pages/ProductsPage"));
const ProductDetailsPage = lazy(() => import("../pages/ProductDetailsPage"));
const CartPage = lazy(() => import("../pages/CartPage"));
const CheckoutPage = lazy(() => import("../pages/CheckoutPage"));
const OrderSuccessPage = lazy(() => import("../pages/OrderSuccessPage"));
const TrackOrderPage = lazy(() => import("../pages/TrackOrderPage"));
const InfoPage = lazy(() => import("../pages/InfoPage"));
const NotFoundPage = lazy(() => import("../pages/NotFoundPage"));

const fallback = <LoadingScreen />;
const lazyPage = (element: React.ReactNode) => <Suspense fallback={fallback}>{element}</Suspense>;

export const router = createBrowserRouter([
  {
    element: <StoreLayout />,
    children: [
      { path: "/", element: lazyPage(<HomePage />) },
      { path: "/products", element: lazyPage(<ProductsPage />) },
      { path: "/category/:categorySlug", element: lazyPage(<ProductsPage />) },
      { path: "/search", element: lazyPage(<ProductsPage />) },
      { path: "/product/:productSlug", element: lazyPage(<ProductDetailsPage />) },
      { path: "/cart", element: lazyPage(<CartPage />) },
      { path: "/checkout", element: lazyPage(<CheckoutPage />) },
      { path: "/order-success/:orderReference", element: lazyPage(<OrderSuccessPage />) },
      { path: "/track-order", element: lazyPage(<TrackOrderPage />) },
      { path: "/about", element: lazyPage(<InfoPage />) },
      { path: "/contact", element: lazyPage(<InfoPage />) },
      { path: "/delivery-policy", element: lazyPage(<InfoPage />) },
      { path: "/privacy-policy", element: lazyPage(<InfoPage />) },
      { path: "/terms", element: lazyPage(<InfoPage />) },
      { path: "*", element: lazyPage(<NotFoundPage />) }
    ]
  }
]);
